"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceEncryptionKeyParamsSchema = exports.EncryptionKeyParamsSchema = exports.CreateEncryptionKeysBodySchema = exports.PassphraseVerificationSchema = exports.PassphraseVerificationBodySchema = void 0;
const v4_1 = require("zod/v4");
const ENCRYPTED_BY_1 = require("../../../../enums/ENCRYPTED_BY");
const PASSPHRASE_FLOW_1 = require("../../../../enums/PASSPHRASE_FLOW");
const common_1 = require("./common");
exports.PassphraseVerificationBodySchema = common_1.EncryptedBlobSchema.extend({
    salt: v4_1.z.string().min(1),
});
exports.PassphraseVerificationSchema = exports.PassphraseVerificationBodySchema.extend({
    flow: v4_1.z.enum(PASSPHRASE_FLOW_1.PASSPHRASE_FLOW),
});
exports.CreateEncryptionKeysBodySchema = v4_1.z.object({
    verification: exports.PassphraseVerificationBodySchema,
    encryptionKeys: v4_1.z.object({
        [ENCRYPTED_BY_1.ENCRYPTED_BY.PASSPHRASE]: common_1.EncryptedBlobSchema,
        [ENCRYPTED_BY_1.ENCRYPTED_BY.RECOVERY_KEY]: common_1.EncryptedBlobSchema,
    }),
});
exports.EncryptionKeyParamsSchema = v4_1.z.object({
    encryptedBy: v4_1.z.enum(ENCRYPTED_BY_1.ENCRYPTED_BY),
});
exports.ReplaceEncryptionKeyParamsSchema = exports.EncryptionKeyParamsSchema.extend({
    encryptedBy: v4_1.z.literal(ENCRYPTED_BY_1.ENCRYPTED_BY.PASSPHRASE),
});
